import React, { useEffect, useState } from 'react'
import { toggleSidebar } from '../../../redux/components/components-slice'
import { useDispatch, useSelector } from 'react-redux'
import DashboardLayout from '../../../components/layouts/dashboard'
import Button from '../../../components/button'
// import { useHistory } from 'react-router-dom';
import FormSelect from '../../../components/form-select'
import EmployeeSVG from '../../../assets/svg/employee-new.svg'
import EmployeePresentSVG from '../../../assets/svg/employee-leave-new.svg'
import EmployeeLeaveSVG from '../../../assets/svg/employee-present-new.svg'
import EmployeeSuspendedSVG from '../../../assets/svg/employee-leave-new.svg'

import Calendar from '../../../assets/svg/calendar-01.svg'
import EmployeeIcon from '../../../assets/svg/employeeIcon.svg'
import ArrowExpand from '../../../assets/svg/arrowExpand.svg'

import EditPencil from '../../../assets/svg/editPencil.svg'

import {
  useGetEmployeesReport,
  useGetHRDashboard,
} from '../../../redux/dashboard/hook'
import LoadingBar from '../../../components/loader-bar'
import { CardHr } from '../../../components/modal/hr-section/dashboard/cardHR'
import { AttendanceCard } from '../../../components/modal/hr-section/dashboard/attendance-card'
import { HRRequests } from '../../../components/modal/hr-section/dashboard/hr-requests'
import HROverviewChart from '../../../components/modal/hr-section/dashboard/HROverviewChart'
import HRChart from '../../../components/modal/hr-section/dashboard/hr-chart'
import {
  useGetUpcomingBirthdays,
  useHelpMeOnboard,
} from '../../../redux/company/hook'
import {
  formatNewDateInWords,
  formatNumber,
  getDateRange,
} from '../../../utils/functions'
import DemoVideoModal from '../../../components/modal/demo-videos'
import SendBirthdayWish from './SendBirthdayWish'
import SendAnnouncement from './SendAnnouncement'
import { useGetAnnouncements } from '../../../redux/employees/hook/announcement'

const HRDashboardPage = () => {
  useEffect(() => {}, [])

  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.userSlice)
  const { data: dashboard, isLoading } = useGetHRDashboard()

  const [dateRange, setDateRange] = useState(getDateRange('Last 12 months'))

  const { data: report, isLoading: reportLoading } =
    useGetEmployeesReport(dateRange)

  const [dashboardCards, setDashboardCards] = useState([])
  const [donutData, setDonutData] = useState(null)
  const [hrStat, setHrStats] = useState(null)

  const [showOnboardingVideo, setShowOnboardingVideo] = useState(false)

  const [attendanceData, setAttendanceData] = useState()

  const [today, setToday] = useState(new Date().getDate())
  const [sendBirthday, setSendBirthday] = useState(false)
  const [employeeBirthday, setEmployeeBirthday] = useState(false)
  const [announcement, setAnnouncement] = useState(false)

  const getWeekDates = () => {
    const weekDays = ['M', 'T', 'W', 'T', 'F', 'S', 'S']
    const todayObj = new Date()
    const dayIndex = todayObj.getDay()
    const mondayOffset = dayIndex === 0 ? -6 : 1 - dayIndex
    const monday = new Date(todayObj.setDate(todayObj.getDate() + mondayOffset))

    return weekDays.map((day, index) => {
      const date = new Date(monday)
      date.setDate(monday.getDate() + index)

      return {
        day,
        date: date.getDate(),
        isToday: date.getDate() === today,
      }
    })
  }

  const [weekData, setWeekData] = useState(getWeekDates())

  useEffect(() => {
    if (dashboard) {
      setAttendanceData({
        title: 'Daily Attendance',
        // day: today,
        // date: todayDate,
        present: {
          name: 'PRESENT',
          value: dashboard ? dashboard.employees_present : 0,
        },
        late: {
          name: 'LATE',
          value: dashboard ? dashboard.employees_late : 0,
        },
        absent: {
          name: 'ABSENT',
          value: dashboard ? dashboard.employees_absent : 0,
        },
      })
      updateHROverview()
      const DashboardCards = [
        {
          title: 'EMPLOYEE STRENGTH',
          value: dashboard ? dashboard.employee_strength : 0,
          icon: EmployeeSVG,
          bgColor: 'bg-[#F8FFE8]',
        },
        {
          title: 'EMPLOYEES PRESENT',
          value: dashboard ? dashboard.employees_present : 0,
          icon: EmployeePresentSVG,
          bgColor: 'bg-[#FFEFD1]',
        },
        {
          title: 'EMPLOYEES ON LEAVE',
          value: dashboard ? dashboard.employees_on_leave : 0,
          icon: EmployeeLeaveSVG,
          bgColor: 'bg-[#F4F8FF]',
        },
        {
          title: 'EMPLOYEES SUSPENDED',
          value: dashboard ? dashboard.employees_suspended : 0,
          icon: EmployeeSuspendedSVG,
          bgColor: 'bg-[#FFF1FF]',
        },
      ]
      setDashboardCards(DashboardCards)
      updateHRStats()
    } else {
      updateHRStats()
      updateHROverview()
      setAttendanceData({
        title: 'Daily Attendance',
        // day: today,
        // date: todayDate,
        present: {
          name: 'PRESENT',
          value: 0,
        },
        late: {
          name: 'LATE',
          value: 0,
        },
        absent: {
          name: 'ABSENT',
          value: 0,
        },
      })
      const DashboardCards = [
        {
          title: 'EMPLOYEE STRENGTH',
          value: 0,
          icon: EmployeeSVG,
          bgColor: 'bg-[#F8FFE8]',
        },
        {
          title: 'EMPLOYEES PRESENT',
          value: 0,
          icon: EmployeePresentSVG,
          bgColor: 'bg-[#FFEFD1]',
        },
        {
          title: 'EMPLOYEES ON LEAVE',
          value: 0,
          icon: EmployeeLeaveSVG,
          bgColor: 'bg-[#F4F8FF]',
        },
        {
          title: 'EMPLOYEE SUSPENDED',
          value: 0,
          icon: EmployeeSuspendedSVG,
          bgColor: 'bg-[#FFF1FF]',
        },
      ]
      setDashboardCards(DashboardCards)
    }
  }, [dashboard])

  useEffect(() => {
    if (window.innerWidth < 851) {
      dispatch(toggleSidebar())
    }
  }, [])

  const [sortOption, setSortOption] = useState('Last 12 months')

  const sortOptions = [
    { value: 'Last 6 months', label: 'Last 6 months' },
    { value: 'Last 12 months', label: 'Last 12 months' },
    { value: 'Last year', label: 'Last year' },
    { value: 'This year', label: 'This year' },
  ]

  const updateHROverview = () => {
    let data = {
      data: {
        labels: ['Male', 'Female'],
        options: {
          plugins: {
            legend: {
              display: false,
            },
          },
        },
        datasets: [
          {
            cutout: '70%',
            label: '# of Votes',
            data: [
              dashboard ? dashboard.male_employees : 0,
              dashboard ? dashboard.female_employees : 0,
            ],
            backgroundColor: ['#238B45', 'rgba(239, 161, 11, 1)'],
          },
        ],
      },
      legends: [
        {
          title: 'Male',
          color: 'bg-[#238B45]',
        },
        {
          title: 'Female',
          color: 'bg-[#f79421]',
        },
      ],
      total: parseInt(
        dashboard ? dashboard.male_employees + dashboard.female_employees : 0
      ),
    }

    setDonutData(data)
  }

  const updateHRStats = () => {
    let data = {
      data: {
        labels: ['', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Mar'],
        datasets: [
          {
            label: 'Count',
            data: [],
            fill: true,
            borderWidth: 2,
            backgroundColor: 'rgb(236,243,251)',
            borderColor: 'rgb(0, 25, 132)',
            tension: 0.5,
            pointRadius: 0.5,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 3,
            pointBorderWidth: 0,
            pointBorderColor: 'rgb(0, 25, 132)',
            pointHoverBorderColor: 'rgb(239, 160, 11)',
          },
        ],
      },
      options: {
        options: {
          plugins: {
            tooltip: {
              backgroundColor: 'rgb(236,243,251)',
              borderColor: 'rgb(236,243,251)',
            },
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              stepSize: 500000,
              // Include a dollar sign in the ticks
              callback: function (value, index, ticks) {
                return formatNumber(parseInt(value), 2)
              },
            },
          },
        },
      },
    }

    dashboard?.lastSixMonthPayroll?.reverse()

    let amounts = []
    let months = []

    dashboard?.lastSixMonthPayroll?.forEach((element) => {
      amounts.push(element.amount)
      months.push(element.month[1])
    })

    data.data.labels = months
    data.data.datasets[0].data = amounts

    setHrStats(data)
  }

  const recentActivity = {
    data: [
      // {
      //   created: '10:40 AM, Fri 22 Mar 2022',
      //   title: 'You posted a new recruitment',
      //   description: 'Kindly check the requirements and terms of work and make sure everything is right.'
      // },
      // {
      //   created: '10:40 AM, Sat 22 Mar 2022',
      //   title: 'You onboarded a new employee',
      //   description: 'Kindly check the requirements and terms of work and make sure everything is right.'
      // },
      // {
      //   created: '10:40 AM, Fri 22 Mar 2022',
      //   title: 'You posted a new recruitment',
      //   description: 'Kindly check the requirements and terms of work and make sure everything is right.'
      // }
    ],
  }
  const requests = {
    advance_request: dashboard ? dashboard.requests.advance_requests : 0,
    reimbursement_requests: dashboard
      ? dashboard.requests.reimbursement_requests
      : 0,
    leave_requests: dashboard ? dashboard.requests.leave_requests : 0,
    others: dashboard ? dashboard.requests.others : 0,
  }

  // const onboard = () => {
  //   history.push('/employees/onboarding/select-option')
  // }
  const { mutateAsync: helpMeOnboard, isLoading: onboardLoading } =
    useHelpMeOnboard()

  const onboard = () => {
    helpMeOnboard()
  }

  useEffect(() => {
    const newDateRange = getDateRange(sortOption)
    setDateRange(newDateRange)
  }, [sortOption])

  const { data: announcements } = useGetAnnouncements(3, 1)

  const { data: upcomingBirthday } = useGetUpcomingBirthdays(4, 1)

  return (
    <DashboardLayout title='People Dashboard'>
      {showOnboardingVideo ? (
        <DemoVideoModal
          isOpen={showOnboardingVideo}
          closeModal={() => setShowOnboardingVideo(false)}
        />
      ) : null}
      {sendBirthday && (
        <SendBirthdayWish
          isOpen={sendBirthday}
          closeModal={() => setSendBirthday(false)}
          employeeBirthday={employeeBirthday}
        />
      )}
      {announcement && (
        <SendAnnouncement
          isOpen={announcement}
          closeModal={() => setAnnouncement(false)}
          employeeBirthday={employeeBirthday}
        />
      )}
      <div className='flex flex-col h-full'>
        <div className='flex flex-col md:flex-row justify-between items-center gap-3 -mt-2'>
          <div className='flex flex-col my-3'>
            <span className='header-3'> Welcome {user?.first_name},</span>
            <span className='text-[13px] text-gray-500'>
              Quick Guide? &nbsp;
              <span
                onClick={() => onboard()}
                className='text-[12px] text-[#0d5225] font-semibold hover:font-extrabold duration-300 cursor-pointer hover:scale-105'
              >
                Click Here
              </span>
            </span>
          </div>
          {/* <div className='w-full md:w-fit md:mt-0'>
            <Button
              text='QUICK GUIDE VIDEOS'
              type='button'
              className={'px-2 gap-2 h-[42px]'}
              leftIcon={'view'}
              textClass={'text-[13px] font-extrabold'}
              // loading={onboardLoading}
              // disabled={onboardLoading}
              onClick={() => {
                setShowOnboardingVideo(true)
              }}
            />
          </div> */}
        </div>
        {isLoading ? (
          <div className='flex flex-col w-full text-center justify-center pb-[25px] pt-[15px]'>
            <LoadingBar loading={isLoading} />
          </div>
        ) : (
          <>
            <div className='grid md:grid-cols-2 lg:grid-cols-4 grid-cols-1 gap-3 w-full'>
              {dashboardCards?.map((item, index) => (
                <CardHr
                  key={index}
                  title={item.title}
                  subtitle={item.value}
                  icon={item.icon}
                  bgColor={item.bgColor}
                />
              ))}
            </div>
            <main className='flex flex-col lg:flex-row gap-3 mt-4  max-w-[800px] w-full'>
              <section className='flex flex-col w-full bg-white p-2 rounded-md border'>
                <div className='flex cursor-pointer flex-col gap-3 bg-[#238B45] p-3 rounded-md'>
                  <h1 className='text-[20px] font-bold text-white'>
                    Company News and Important Updates.
                  </h1>
                  <button
                    onClick={() => {
                      setAnnouncement(true)
                    }}
                    className='bg-white cursor-pointer rounded-md p-2 text-sm font-medium w-[217px]'
                  >
                    Create New Announcement
                  </button>
                </div>
                <div className='flex flex-col gap-3 mt-4'>
                  {announcements?.data?.map((a, index) => (
                    <div
                      key={index}
                      className={`flex items-center pb-3 gap-2 ${
                        index !== announcements?.data?.length - 1
                          ? 'border-b border-b-gray-300'
                          : ''
                      }`}
                    >
                      <div>
                        <img src={Calendar} alt='centelHr' />
                      </div>
                      <div className='flex flex-col'>
                        <h1 className='text-sm font-medium'>{a.title}</h1>
                        <p className='text-xs text-gray-500'>
                          {formatNewDateInWords(a.publish_date)}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </section>
              <section className='flex flex-col w-full bg-white p-2 rounded-md border'>
                <div className='flex justify-between items-start'>
                  <div>
                    <h2 className='text-lg font-medium'>
                      Upcoming Birthdays 
                    </h2>
                    <p className='text-sm text-gray-500'>
                      Don't miss a chance to wish a happy birthday!
                    </p>
                  </div>
                  <div className='mt-2'>
                    <img src={ArrowExpand} alt='centelHr' />
                  </div>
                </div>

                <div className='flex flex-col gap-3 mt-4'>
                  {upcomingBirthday?.map((birthday, index) => (
                    <div
                      key={birthday.id}
                      className={`flex justify-between w-full items-center pb-3 gap-2 ${
                        index !== upcomingBirthday.length - 1
                          ? 'border-b border-b-gray-300'
                          : ''
                      }`}
                    >
                      <div className='flex items-center gap-2'>
                        <div>
                          <img src={Calendar} alt='centelHr' />
                        </div>
                        <div className='flex flex-col'>
                          <h1 className='text-sm font-medium'>
                            {birthday.first_name} {birthday?.last_name}
                          </h1>
                          <p className='text-xs text-gray-500'>
                            {formatNewDateInWords(birthday.dob)}
                          </p>
                        </div>
                      </div>
                      {birthday.is_birthday === 1 ? (
                        <img
                          src={EditPencil}
                          alt='edit'
                          onClick={() => {
                            setEmployeeBirthday(birthday)
                            setSendBirthday(true)
                          }}
                          className='w-9 h-9 cursor-pointer rounded-full object-cover'
                        />
                      ) : (
                        <img
                          src={EmployeeIcon}
                          alt='employee'
                          className='w-9 h-9 rounded-full object-cover'
                        />
                      )}
                    </div>
                  ))}
                </div>
              </section>
            </main>
            <div className='flex lg:flex-row w-full flex-col gap-4 mt-4'>
              <div className='lg:w-[67%] w-full bg-color-white h-[500px] lg:h-[560px] flex flex-col py-[15px] overflow-auto border rounded-md'>
                <div className='flex w-full flex-col h-full justify-between'>
                  {/* HR Stat */}
                  <div className='w-[100%] h-full flex flex-col mb-2'>
                    <div className='flex flex-row justify-between items-center px-4 pt-2'>
                      <span className='p2'>Performance Statistics</span>
                      <div className='hidden md:flex flex-row items-center gap-2'>
                        <div className='bg-hr-primary-1/50 w-[10px] h-[10px] rounded-[10px] pr-2'></div>
                        <span className='p4'>People Management.</span>
                      </div>
                      <div className='flex items-center h-[27px]'>
                        <FormSelect
                          defaultValue={sortOption}
                          options={sortOptions}
                          onChange={(selected) => {
                            setSortOption(selected)
                          }}
                          type='default'
                          extraClass='h-[27px] w-[140px] !text-[12px]'
                        />
                      </div>
                    </div>
                    <hr className='divider' />
                    <div className='h-full w-[100%] px-4 '>
                      {!reportLoading ? (
                        <HRChart data={report} />
                      ) : (
                        <LoadingBar loading={reportLoading} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className='lg:w-[33%] w-full flex flex-col gap-2'>
                <div className='w-[100%] h-fit'>
                  {attendanceData ? (
                    <AttendanceCard
                      attendanceData={attendanceData}
                      weekData={weekData}
                    />
                  ) : null}
                </div>
                <div className='flex flex-col items-center justify-center gap-2'>
                  <div className='w-[100%] h-fit bg-color-white'>
                    <HRRequests requests={requests} donutData={donutData} />
                  </div>
                </div>
                {/* <div className='w-[100%] h-fit mt-3'>
                <RecentActivity recentActivity={recentActivity} />
              </div> */}
              </div>
            </div>
          </>
        )}
      </div>
    </DashboardLayout>
  )
}

export default HRDashboardPage
